import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { FormSpyRenderProps } from 'react-final-form';
import { FormSpy, useForm } from 'react-final-form';

import type { TFields, TResident } from '../../models/analytics';

import { Sender } from './sender';
import type { IAnalyticsSpy, TMappedFields } from './models';

const Middle: FC<FormSpyRenderProps<TFields & TResident> & IAnalyticsSpy> = ({
    active,
    analytics,
    errors,
}) => {
    const { touched, values } = useForm().getState();
    /**
     * конструирование объекта, содержащего информацию о состоянии поля
     * зависит только от `active` и `errors`, потому что аналитика отправляется только на изменения фокуса и валидацию
     * */
    const fields = useMemo(
        () =>
            Object.entries(touched as Record<TFields, boolean>).reduce<TMappedFields>(
                (acc, [key, value]) => {
                    acc[key as TFields] = {
                        touched: value,
                        error: errors[key],
                        value: values[key],
                    };

                    return acc;
                },
                { ...touched }
            ),
        [touched, errors, values]
    );
    /**
     * при первом рендере объект `touched` пуст
     * */
    if (Object.keys(fields).length === 0) {
        return null;
    }

    return <Sender active={active as TFields} analytics={analytics} fields={fields} />;
};

export const AnalyticsSpy: FC<IAnalyticsSpy> = ({ analytics }) => (
    <FormSpy
        analytics={analytics}
        // @ts-ignore
        component={Middle}
        subscription={{
            active: true,
            errors: true,
            values: true,
        }}
    />
);
